module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAQCAMAAAAs2N9uAAAAY1BMVEUAAABUXGZUXGZUXGZUXGZUXGZUXGZUXGZUXGZUXGZUXGZUXGZUXGZUXGZUXGZUXGZUXGZUXGZUXGZUXGZUXGZUXGZUXGZUXGZUXGZUXGZUXGZUXGZUXGZUXGZUXGZUXGZUXGaYi3xxAAAAIHRSTlMA+AV859q8gWxQ1I50WUMtIhvyy8etqYg7OCbtoZJkEjy1C64AAACISURBVBjTZZBbDoQgDEVbUFRU8DXj6Lzu/lcpQiofng9KTtKbthQZq+WN4tErEjQjUb6SUM/w79zWfxjcRFUBOnXsFuxDHRhaEv4lTCgrLF00wEAawDe7AjVRh5UyBm14N7opQRpjZjbujD/DajHKwqRRxY0L2MtC88/vrp3SQve15TjzdB3nANu0CcFA8sVKAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./components/Icon/images/icon_turn_l.png
// module id = T6Hx
// module chunks = 9